var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"mt-10"},[_c('v-autocomplete',{attrs:{"auto-select-first":"","rounded":"","solo-inverted":"","label":"공식을 선택하세요","items":_vm.formulaNames,"color":"white"},on:{"change":_vm.onChangeSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }